import React from "react"
import { Dimensions, StyleSheet, View } from "react-native"
import Constants from "expo-constants"
import { StatusBar } from "expo-status-bar"

const { width, height } = Dimensions.get("screen")
export const ContainerGlogal = (props) => {
    return (
        <View style={[styles.container, props.style]}>
            <StatusBar translucent />
            {props.children}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingTop: Constants.statusBarHeight
    }
})
